module.exports = require("@angular/cdk/a11y");


//////////////////
// WEBPACK FOOTER
// external "@angular/cdk/a11y"
// module id = 134
// module chunks = 0